import { render, staticRenderFns } from "./AppDescriptionTab.vue?vue&type=template&id=1d5b4408&scoped=true"
import script from "./AppDescriptionTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDescriptionTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppDescriptionTab.vue?vue&type=style&index=0&id=1d5b4408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b4408",
  null
  
)

export default component.exports